const API_LINKS = {
  GET_ANALYTICS: '/admin/analytics',
  UPDATE_PREMIUM_REQUEST: '/admin/users/premium-request',
  BASE_URL: process.env.REACT_APP_BACKEND_API_URL,
  GET_BOOKINGS: '/booking/bookings',
  GET_BOOKING: '/admin/bookings',
  DOWNLOAD_BOOKINGS: '/admin/bookings/all',
  GET_CLASS: '/admin/classes',
  DOWNLOAD_CLASSES: '/admin/classes/download',
  GET_USERS_CLASS: '/admin/class/user',
  GET_TRANSACTION: '/admin/transactions',
  GET_ADMIN: '/admin',
  GET_USERS: '/admin/users',
  DOWNLOAD_USERS: '/admin/users/download',

  //Settings,
  GET_SETTINGS: '/admin/settings',
  UPDATE_SETTINGS: '/admin/settings/edit',

  // BookingFees
  GET_BOOKING_FEE: '/admin/bookings-fees',
  GET_ADMIN_SERVICES: '/admin/services',
  ADD_BOOKING_FEE: '/admin/bookings-fees',
  UPDATE_BOOKING_FEE: '/admin/bookings-fees/edit',
  GET_BOOKINGS_CLASS: '/admin/bookings/get',
  EDIT_CLASS: '/admin/classes',

  //Categories
  GET_CATEGORIES: '/admin/categories',

  //Subscriptions
  GET_USER_SUBSCRIPTIONS: '/admin/users/subscriptions',

  //Subadmin,
  GET_SUBADMIN: '/admin/sub-admin',
}

export default API_LINKS
